import { render } from "./ListeTableauIMDG.vue?vue&type=template&id=2271abcb&ts=true"
import script from "./ListeTableauIMDG.vue?vue&type=script&lang=ts"
export * from "./ListeTableauIMDG.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__